export default "<app-billing-tab [reportSection]=\"reportSection\"></app-billing-tab>";